import React, { FunctionComponent } from 'react'
import Script from 'next/script'

import { app } from '../../env'
const { DYSCAN_SRC } = app

export const DyScan: FunctionComponent = () => {
  return <Script src={DYSCAN_SRC} strategy='beforeInteractive' />
}
